import { useContext } from 'react';
import {
  Skeleton,
  Box,
  Typography,
} from '@mui/material';
import { Section } from '../../../components/ui/Section';
import WasteChecksheetTable from './WasteChecksheetTable';
import { theme } from '../../../theme';
import { Pill } from '../../../components/shared/Pill';
import { WasteChecksheetDetailContext, WasteChecksheetDetailValues } from '../contexts/WasteChecksheetDetailContext';


const WasteChecksheetMainBox = () => {
  const { isLoading,
    itemsData,
    itemsByCategory,
    isMobile,
  } = useContext(WasteChecksheetDetailContext) as WasteChecksheetDetailValues;

  if (isLoading || itemsByCategory.length == 0) return <>
    {isMobile && <Skeleton variant="rectangular"
      height={40}
      sx={{ borderRadius: '12px', mb: '12px' }} />}
    <Skeleton variant="rectangular"
      height={1000}
      sx={{ borderRadius: '12px' }} />
  </>;

  return (
    <Section>
      <Box sx={{ p: 5 }}>
        <Typography variant='textMD'
          fontWeight={600}
          sx={{ display: 'flex', alignItems: 'center' }}>
          {'Waste Checksheet'}
          <Pill text={`${itemsData.itemCount} Items`}></Pill>
          <Pill text={`${itemsByCategory.length} Categories`}
            pallet={theme.palette.warning}></Pill>
        </Typography>
      </Box>
      {itemsByCategory.map((category, categoryIndex) => (
        <WasteChecksheetTable key={category.name}
          category={category}
          categoryIndex={categoryIndex} />))}
    </Section >
  );
};

export default WasteChecksheetMainBox;